var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1046",
    "data-name": "Group 1046",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    "data-name": "Path 4084",
    d: "M30,57.067A27.067,27.067,0,1,0,2.933,30,27.067,27.067,0,0,0,30,57.067ZM30,58A28,28,0,1,1,58,30,28,28,0,0,1,30,58Z",
    transform: "translate(-2 -2)",
    fill: "#dde4eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M30.267,54.533A24.267,24.267,0,1,1,54.533,30.267,24.267,24.267,0,0,1,30.267,54.533Zm0-7.467a16.8,16.8,0,1,0-16.8-16.8A16.8,16.8,0,0,0,30.267,47.067Z",
    transform: "translate(-2.267 -2.267)",
    fill: "#dde4eb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullPayment);
export default __webpack_public_path__ + "static/media/full-payment.f6965466.svg";
export { ForwardRef as ReactComponent };